var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4445_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 16C11.9997 16.7956 11.6836 17.5587 11.121 18.1213C10.5584 18.6839 9.79533 19 8.99968 19C8.20403 19 7.44097 18.6839 6.87836 18.1213C6.31575 17.5587 5.99968 16.7956 5.99968 16M3.04268 16C2.69935 15.9999 2.36166 15.9126 2.0612 15.7465C1.76075 15.5803 1.50734 15.3407 1.32468 15.05C1.13925 14.7589 1.02919 14.4262 1.0044 14.082C0.979606 13.7377 1.04087 13.3927 1.18268 13.078L1.72768 11.866C2.3849 10.4016 2.77568 8.83165 2.88168 7.23L2.91268 6.757C3.01441 5.20077 3.69889 3.74003 4.82968 2.666C5.95511 1.59851 7.44651 1.00237 8.99768 1C10.5488 1.00237 12.0403 1.59851 13.1657 2.666C14.2962 3.73978 14.9807 5.20012 15.0827 6.756L15.1137 7.23C15.2197 8.83165 15.6105 10.4016 16.2677 11.866L16.8137 13.077C16.9568 13.3919 17.0191 13.7375 16.995 14.0825C16.9709 14.4275 16.8612 14.7611 16.6757 15.053C16.4922 15.3439 16.2379 15.5834 15.9365 15.749C15.6351 15.9147 15.2966 16.001 14.9527 16H3.04268Z",
    stroke: "#4E4E4E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4445_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaciones);
export default __webpack_public_path__ + "static/media/notificaciones.69df8b0b793f240bc96329950e97bd2a.svg";
export { ForwardRef as ReactComponent };